// Alert 层级管理
//
// 约定（全站）：
// - 顶栏提示（AlertMessage）固定使用 GLOBAL_ALERT_Z_INDEX，且为全站 z-index 上限；其它业务样式、
//   Modal/Drawer/Dropdown、自定义 overlay 等均须保持低于该值（建议不超过 Z_INDEX_BUSINESS_MAX）。
// - 下列 ALERT_Z_INDEX 键名仅为历史兼容，数值与 GLOBAL_ALERT_Z_INDEX 一致；新代码请使用 GLOBAL_ALERT_Z_INDEX。

/** 顶栏 AlertMessage 固定层叠值；全站其它 z-index 须低于本值 */
export const GLOBAL_ALERT_Z_INDEX = 2147483646;

/** 业务自定义弹层、下拉等建议上限（远低于 GLOBAL，便于维护） */
export const Z_INDEX_BUSINESS_MAX = 100000;

export const ALERT_Z_INDEX = {
  GLOBAL_TOP: GLOBAL_ALERT_Z_INDEX,
  LOGIN: GLOBAL_ALERT_Z_INDEX,
  MY_WORK: GLOBAL_ALERT_Z_INDEX,
  NAVBAR: GLOBAL_ALERT_Z_INDEX,
  VOICE_CLONE: GLOBAL_ALERT_Z_INDEX,
  LISTEN_SOUND: GLOBAL_ALERT_Z_INDEX,
  UPLOAD_VIDEO: GLOBAL_ALERT_Z_INDEX,
  ABOVE_HIGH_AUTO_MODEL: GLOBAL_ALERT_Z_INDEX,
} as const;

// Alert 类型
export type AlertType = 'success' | 'error' | 'info' | 'warning';

// Alert 配置接口
export interface AlertConfig {
  type: AlertType;
  message: string;
  duration?: number;
  closable?: boolean;
}

// 全局 Alert 管理器
class AlertManager {
  private static instance: AlertManager;
  private alerts: Map<string, AlertConfig> = new Map();

  static getInstance(): AlertManager {
    if (!AlertManager.instance) {
      AlertManager.instance = new AlertManager();
    }
    return AlertManager.instance;
  }

  // 显示 Alert
  show(id: string, config: AlertConfig): void {
    this.alerts.set(id, config);
  }

  // 隐藏 Alert
  hide(id: string): void {
    this.alerts.delete(id);
  }

  // 获取 Alert
  get(id: string): AlertConfig | undefined {
    return this.alerts.get(id);
  }

  // 获取所有 Alert
  getAll(): Map<string, AlertConfig> {
    return this.alerts;
  }

  // 清除所有 Alert
  clear(): void {
    this.alerts.clear();
  }
}

export default AlertManager.getInstance();
